import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Twicpics from 'lib/tags/twicpics'

import './styles.scss'

export default function Course ({ course, width, dpr }) {
  return (
    <div className='course' style={{ position: 'relative', zIndex: 999 }}>
      <a href={course.url} target='_blank' aria-label={course.avatar_alt} rel='noreferrer'>
        <Twicpics src={course.avatar} width={width} height={width} alt={course.avatar_alt} dpr={dpr} lazyLoad />
        {course.user_verified ? (
          <div
            className='react-verified-badge-small'
            data-user-id={course.user_id}
            style={{ position: 'absolute', top: width - 8, right: 12 }}
          />
        ) : null}
      </a>
      <br />
      <div className='name'>{course.user_name}</div>
      <a className='title-short' href={course.url} target='_blank' rel='noreferrer'>
        {course.title}
      </a>
      <div className='description'>{course.description}</div>
    </div>
  )
}

Course.propTypes = {
  course: PropTypes.object.isRequired,
  width: PropTypes.number.isRequired,
  dpr: PropTypes.number
}
